export default "__VITE_ASSET__CA$7cmj$__"